import { TLegacyUserWithAccount } from "../api/types/User";
import { APP_CONFIG } from "../constants/constants";
import { localStorageKeys } from "./localStorageItems";

export const phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
export const phoneNumbersOnlyRegex = /^[0-9]{10}$/;

export function yupTestCheckFileSize(file?: File): boolean {
  let valid = true;
  const user = localStorage.getItem(
    localStorageKeys.user
  ) as any as TLegacyUserWithAccount;
  const maxFileSizeInMb =
    !!user?.config?.DOCUMENT_UPLOAD_SIZE_LIMIT_IN_MB &&
    !isNaN(user?.config?.DOCUMENT_UPLOAD_SIZE_LIMIT_IN_MB)
      ? user?.config?.DOCUMENT_UPLOAD_SIZE_LIMIT_IN_MB
      : APP_CONFIG.DOCUMENT_UPLOAD.MAX_FILE_SIZE_MB;
  if (file) {
    if (file.size > maxFileSizeInMb * 1024 * 1024) {
      valid = false;
    }
  }
  return valid;
}

export function yupTestCheckFileType(file?: File): boolean {
  let valid = true;
  if (file) {
    if (
      !APP_CONFIG.DOCUMENT_UPLOAD.ALLOWED_FILE_EXT.includes(
        file.name.split(".").pop() || ""
      )
    ) {
      valid = false;
    }
  }
  return valid;
}
